import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UtilService } from '@app/shared/services/util.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { apiClientService } from './api-client.service';

@Component({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, RouterModule],
    selector: 'app-api-client',
    templateUrl: './api-client.component.html',
    styleUrls: ['./api-client.component.css']
})
export class ApiClientComponent {
  url: string = '';
  method: string = 'GET';
  allMappings: any[] = [];
  reverseMapping: any = {
    'course': 'Courses',
    'question': 'Questions',
    'questionPaper': 'Question Papers',
    'assessment': 'Assessments'
  }
  allQuestionTypes: any = [
    { id: 1, name: "Multiple Choice Question" },
    { id: 2, name: "True/False Question" },
    { id: 3, name: "Fill In The Blanks Question" },
    { id: 4, name: "Matching Questions" },
    { id: 5, name: "Subjective Answer Question" },
    { id: 6, name: "Scenario Based Question" },
    { id: 7, name: "Multi-select Question" },
    { id: 8, name: "Activity - Performance Task" },
    { id: 9, name: "Activity - Audio/Video Response" },
    { id: 10, name: "Activity - Real-time Video Streaming Based Viva" },
    { id: 11, name: "Activity - File Submission" }
  ]
   difficultyLevel: any = [
    { id: 1, name: "Easy" },
    { id: 2, name: "Medium" },
    { id: 3, name: "Difficult" }
  ]
  // State for inputs
  headers: {
    key: string;
    value: string;
    showSuggestions: boolean;
    filteredSuggestions: string[];
  }[] = [
    {
      key: '',
      value: '',
      showSuggestions: false,
      filteredSuggestions: []
    }
  ];
  queryParams: { key: string; value: string }[] = [
    { key: '', value: '' }
  ];
  body: string = '';

  response: any;
  isArray: boolean = false;

  // Table state
  pageSize = 10;
  totalPages = 0;
  currentPage: any = 1;
  paginatedData: any[] = [];
  selected: Set<number> = new Set();
  selectAllAcrossPages = false;
  isLoading: boolean = false;
  payload: any;
  selectedModule: any = '';
  selectedMappingId: any = '';
  integrationId: number | null = null;
  name: string = '';

  // Body options
  commonHeaders: string[] = [
    'Content-Type',
    'Accept',
    'Authorization',
    'User-Agent',
    'Cache-Control',
    'Accept-Encoding',
    'Accept-Language',
    'Connection',
    'Referer',
    'Origin',
    'Host'
  ];
  bodyTypes = ['none', 'raw', 'form-data', 'x-www-form-urlencoded', 'binary', 'GraphQL'];
  bodyType: string = 'none';

  // Raw body type
  rawBodyType: string = 'JSON';

  // Form-data
  formData: { key: string, value: string, type: string }[] = [];

  // x-www-form-urlencoded
  urlEncoded: { key: string, value: string }[] = [];

  // Binary
  binaryFile: File | null = null;

  // GraphQL
  graphqlQuery: string = '';
  graphqlVariables: string = '';

  // Add/remove handlers
  addFormData() { this.formData.push({ key: '', value: '', type: 'text' }); }
  removeFormData(i: number) { this.formData.splice(i, 1); }

  addUrlEncoded() { this.urlEncoded.push({ key: '', value: '' }); }
  removeUrlEncoded(i: number) { this.urlEncoded.splice(i, 1); }

  onBinaryFileSelected(event: any) {
    this.binaryFile = event.target.files[0];
  }

  showCurlModal = false;
  curlInput = '';
  selectedAttribute: string = ''; // default = entire response
  dataToRender: any[] = [];

  constructor(
    private http: HttpClient,
    private util: UtilService,
    private logger: LoggerService,
    private cdr: ChangeDetectorRef,
    private service: apiClientService
  ) {}

  ngOnInit() { 
    this.getMappings();
    this.updateSelectedAttribute();
    const id = localStorage.getItem('integrationId');

    if (id) {
    this.integrationId = Number(id);
    this.loadIntegration(this.integrationId);
  }


  }
loadIntegration(id: number): void {

  this.service.getIntegrationById(id)
    .subscribe({

      next: (res: any) => {

        const data = res.body.responseBody;

        this.method = data.method;
        this.url = data.url;

        this.headers = Object.entries(data.headers || {}).map(
          ([key, value]) => ({
            key: key,
            value: String(value),
            showSuggestions: false,
            filteredSuggestions: []
          })
        );

        this.queryParams = Object.entries(data.query_params || {}).map(
          ([key, value]) => ({
            key: key,
            value: String(value)
          })
        );

        this.body = JSON.stringify(data.body || {}, null, 2);

      }

    });

}
saveIntegration() {

  const payload = {

  id: this.integrationId || 0,   

  name: this.name || 'API Integration',

  method: this.method,

  url: this.url.trim(),

  headers: this.headers
    .filter(h => h.key && h.value)
    .map(h => ({
      key: h.key,
      value: h.value
    })),

  query_params: this.queryParams
    .filter(q => q.key && q.value)
    .map(q => ({
      key: q.key,
      value: q.value
    })),

  body: this.body || null,

  body_type: this.bodyType,

  mapping_id: this.selectedMappingId || null,

  module: this.selectedModule || null

};

  if (this.integrationId) {

    this.service.updateIntegration(this.integrationId, payload)
      .subscribe(() => {

        this.util.simpleDialog({
          title: 'Success',
          message: 'Integration updated successfully'
        });

      });

  }
  else {

    this.service.createIntegration(payload)
      .subscribe(() => {

        this.util.simpleDialog({
          title: 'Success',
          message: 'Integration created successfully'
        });

      });

  }

}

  getMappings() {
    this.service.getAllMapping().subscribe(
      (data: any) => {
        const responseBody = data.body.responseBody;
        this.allMappings = responseBody.map((item: any) => {
          item.status = item.is_archived ? '0' : item.is_active ? '1' : '2';
          return { ...item };
        })
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (err) => {
        this.util.showLoader = false;
        this.util.simpleDialog({
          title: 'Error',
          message: err,
        });
        console.error('Error fetching mappings:', err);
        this.logger.error('Error fetching mappings:', err);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  addQueryParam() {
    this.queryParams.push({ key: '', value: '' });
  }

  transformData(data: any[]) {

    // 1. Data must be an array
    if (!Array.isArray(data)) {
      return { error: true, message: "Invalid input. Data must be an array." };
    }

    // 2. Empty array case
    if (data.length === 0) {
      return { error: true, message: "No data present." };
    }

    // 3. Ensure module and mapping are selected
    if (!this.selectedModule || !this.selectedMappingId) {
      return { error: true, message: "Module or mapping configuration not selected." };
    }

    // 4. Find mapping config using selectedMappingId
    const mappingRow = this.allMappings.find(m => m.id == this.selectedMappingId);

    if (!mappingRow || !mappingRow.mapping_config) {
      return { error: true, message: "Mapping configuration not found." };
    }

    // 5. Extract mapping for the selected module
    const currModuleName = this.reverseMapping[this.selectedModule] || this.selectedModule;

    // Check if mapping exists
    if (!mappingRow.mapping_config || !(currModuleName in mappingRow.mapping_config)) {
      return { error: true, message: `Mapping configuration missing for module: ${currModuleName}`};
    }

    if(this.selectedModule === 'questionPaper' && !('Questions' in mappingRow.mapping_config)) {
      return { error: true, message: `Mapping configuration missing for module: Questions`};
    }

    if(this.selectedModule === 'assessment' && !('Candidates' in mappingRow.mapping_config)) {
      return { error: true, message: `Mapping configuration missing for module: Candidates`};
    }

    let moduleMapping = mappingRow.mapping_config[currModuleName] || {};

    if (this.selectedModule === 'assessment') {
      const qpMapping = mappingRow.mapping_config?.['Question Papers'];
      if (qpMapping) {
        moduleMapping = { ...moduleMapping, ...qpMapping };
      }
    }


    // 6. Transform the data
    const transformed = data.map(item => {
      const newObj: any = { ...item };

      // ---------------------------
      // TOP-LEVEL MAPPING
      // ---------------------------
      for (const targetKey in moduleMapping) {
        const sourceKey = moduleMapping[targetKey];
        if (sourceKey in newObj) {
          const tempValue = newObj[sourceKey];
          delete newObj[sourceKey];
          newObj[targetKey] = tempValue;
        }
      }

      // ---------------------------
      // QUESTIONS MAPPING
      // ---------------------------
      if (Array.isArray(item.questions)) {
        const qMapping = mappingRow.mapping_config["Questions"] || {};

        newObj.questions = item.questions.map(q => {
          const qObj: any = { ...q };

          for (const targetKey in qMapping) {
            const sourceKey = qMapping[targetKey];
            if (!(sourceKey in qObj)) continue;

            let tempValue = qObj[sourceKey];
            delete qObj[sourceKey];

            if (targetKey === "questionTypeId") {
              const match = this.allQuestionTypes.find(
                t => t.name.toLowerCase().trim() === String(tempValue).toLowerCase().trim()
              );
              qObj[targetKey] = match ? String(match.id) : null;
            }

            else if (targetKey === "difficultyLevelId") {
              const match = this.difficultyLevel.find(
                d => d.name.toLowerCase().trim() === String(tempValue).toLowerCase().trim()
              );
              qObj[targetKey] = match ? String(match.id) : null;
            }

            else {
              qObj[targetKey] = tempValue;
            }
          }

          return qObj;
        });
      }

      // ---------------------------
      // CANDIDATES MAPPING
      // ---------------------------
      if (Array.isArray(item.candidates)) {
        const cMapping = mappingRow.mapping_config["Candidates"] || {};

        newObj.candidates = item.candidates.map(c => {
          const cObj: any = { ...c };

          for (const targetKey in cMapping) {
            const sourceKey = cMapping[targetKey];
            if (!(sourceKey in cObj)) continue;

            const tempValue = cObj[sourceKey];
            delete cObj[sourceKey];    // always delete original source key

            // Apply mapping rule directly (no special conversions unless you need later)
            cObj[targetKey] = tempValue;
          }

          return cObj;
        });
      }

      return newObj;
    });

    return { error: false, data: transformed };
  }

  syncNow(){
    // Validate required selections
    if (!this.selectedModule) {
      this.util.simpleDialog({
        title: 'Error',
        message: "Please select Module before syncing."
      });
      return;
    }
    if (!this.selectedMappingId) {
      this.util.simpleDialog({
        title: 'Error',
        message: "Please select Mapping Config before syncing.",
      });
      return;
    }

    this.isLoading=true;
    // Transform data
    const result = this.transformData(this.dataToRender);

    if (result.error) {
      this.util.simpleDialog({
        title: 'Error',
        message: result.message || "Error transforming data.",
      });
      return;
    }
    // Assign transformed data to payload
    this.payload = result.data;
    this.service.sendRequest(this.payload, this.selectedModule).subscribe(
    (data: any) => {
      const responseHead = data.body.responseHead;
      const successMsg = responseHead
        ? this.util.getSuccessMessage(
          'SEND_REQUEST',
          responseHead.statusCode,
          responseHead.statusDesc
        )
        : responseHead;
      this.util.simpleDialog({
        title: 'Success',
        message: successMsg,
      });
    },
    (err) => {
      this.isLoading = false;
      this.cdr.detectChanges();
      this.util.simpleDialog({
        title: 'Error',
        message: 'Error in pulling data',
      });
      console.error('Error sending payload:', err);
      this.logger.error('Error sending payload:', err);
    })
  }

  //Send Request
  async sendRequest() {
      this.url = this.url.trim();
    try {
      // Build headers
      const headers: Record<string, string> = {};
      this.headers.forEach(h => {
        if (h.key && h.value) headers[h.key] = h.value;
      });

      // Build query params
      let queryString = '';
      if (this.queryParams.some(p => p.key && p.value)) {
        const params = new URLSearchParams();
        this.queryParams.forEach(p => {
          if (p.key && p.value) params.append(p.key, p.value);
        });
        queryString = `?${params.toString()}`;
      }

      // Prepare request options
      const options: RequestInit = {
        method: this.method,
        headers
      };

      // Attach body if needed
      if (this.method !== 'GET' && this.method !== 'DELETE') {
        if (this.bodyType === 'raw') {
          options.body = this.body;
        } else if (this.bodyType === 'form-data') {
          const form = new FormData();
          this.formData.forEach(fd => {
            if (fd.type === 'file') {
              // In a real case, you'd resolve file input instead of just string
              form.append(fd.key, new File([], fd.value));
            } else {
              form.append(fd.key, fd.value);
            }
          });
          options.body = form;
        } else if (this.bodyType === 'x-www-form-urlencoded') {
          const params = new URLSearchParams();
          this.urlEncoded.forEach(u => params.append(u.key, u.value));
          options.body = params.toString();
        } else if (this.bodyType === 'GraphQL') {
          options.body = JSON.stringify({
            query: this.graphqlQuery,
            variables: this.graphqlVariables
              ? JSON.parse(this.graphqlVariables)
              : {}
          });
          headers['Content-Type'] = 'application/json';
        }
      }

      // Execute request with fetch
      const res = await fetch(this.url + queryString, options);

      // Try parsing JSON, fallback to text
      let data;
      const text = await res.text();
      try {
        data = JSON.parse(text);
      } catch {
        data = text;
      }

      this.response = data;
      this.updateSelectedAttribute();
      this.saveIntegration();
      this.cdr.markForCheck();

    } catch (err: any) {
      this.util.simpleDialog({
        title: 'Error',
        message: 'Something went wrong while processing the request.'
      });
      console.error('Error during API call:', err);
      this.logger.error('Error during API call:', err);
      this.response = err?.message || 'Unknown error';
      this.isArray = false;
      this.cdr.markForCheck();
    }
  }

  //Attribute selection
  updateSelectedAttribute() {
    let extracted = this.response;

    if (this.selectedAttribute) {
      extracted = this.response?.[this.selectedAttribute];
    }

    if (Array.isArray(extracted)) {
      this.dataToRender = extracted;
      this.isArray = true;
      this.currentPage = 1;
      this.updatePaginatedData();
    } else {
      this.isArray = false;
      this.dataToRender = extracted;
    }
  }

  //Pagination
  updatePaginatedData() {
    if (!Array.isArray(this.dataToRender)) return;

    this.totalPages = Math.ceil(this.dataToRender.length / this.pageSize);
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedData = this.dataToRender.slice(start, end);
  }

  getPageNumbers(): (number | string)[] {
    const pages: (number | string)[] = [];
    const maxShown = 5;

    if (this.totalPages <= maxShown) {
      for (let i = 1; i <= this.totalPages; i++) pages.push(i);
    } else {
      if (this.currentPage <= 3) {
        pages.push(1, 2, 3, '...', this.totalPages);
      } else if (this.currentPage >= this.totalPages - 2) {
        pages.push(1, '...', this.totalPages - 2, this.totalPages - 1, this.totalPages);
      } else {
        pages.push(1, '...', this.currentPage - 1, this.currentPage, this.currentPage + 1, '...', this.totalPages);
      }
    }
    return pages;
  }

  goToPage(page: number | string) {
    if (typeof page === 'number') {
      this.currentPage = page;
      this.updatePaginatedData();
    }
  }
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedData();
    }
  }
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedData();
    }
  }

  // Selection
  toggleSelect(index: number) {
    const globalIndex = (this.currentPage - 1) * this.pageSize + index;
    if (this.selected.has(globalIndex)) this.selected.delete(globalIndex);
    else this.selected.add(globalIndex);
  }

  toggleSelectAllAcrossPages() {
    this.selectAllAcrossPages = !this.selectAllAcrossPages;
    if (this.selectAllAcrossPages) {
      this.selected = new Set(this.dataToRender.map((_: any, i: number) => i));
    } else {
      this.selected.clear();
    }
  }

  getRawPlaceholder(): string {
    switch (this.rawBodyType) {
      case 'JSON':
        return '{\n  "key": "value"\n}';
      case 'Text':
        return 'Enter plain text here...';
      case 'HTML':
        return '<div>\n  Hello World\n</div>';
      case 'XML':
        return '<note>\n  <to>User</to>\n</note>';
      default:
        return '';
    }
  }

  removeQueryParam(index: number) {
    this.queryParams.splice(index, 1);
  }

    openCurlImport() {
    this.showCurlModal = true;
  }

  closeCurlImport() {
    this.showCurlModal = false;
    this.curlInput = '';
  }

  parseCurl() {
  let curl = this.curlInput.trim();

  if (!curl.startsWith("curl")) {
    this.util.simpleDialog({
      title: "Error",
      message: "Not a valid cURL command"
    });
    return;
  }

  // Remove line continuation backslashes
  curl = curl.replace(/\\\s*\n/g, " ");

  // Tokenize: split by space but respect quotes
  const tokens: string[] = [];
  let current = "";
  let inSingle = false;
  let inDouble = false;

  for (let i = 0; i < curl.length; i++) {
    const char = curl[i];

    if (char === "'" && !inDouble) {
      inSingle = !inSingle;
      continue;
    }
    if (char === '"' && !inSingle) {
      inDouble = !inDouble;
      continue;
    }
    if (char === " " && !inSingle && !inDouble) {
      if (current) {
        tokens.push(current);
        current = "";
      }
      continue;
    }
    current += char;
  }
  if (current) tokens.push(current);

  // Reset defaults
  this.method = "GET";
  this.url = "";
  this.headers = [];
  this.queryParams = [];
  this.body = "";
  this.bodyType = "none";
  this.formData = [];
  this.urlEncoded = [];
  this.binaryFile = null;
  this.graphqlQuery = "";
  this.graphqlVariables = "";

  try {
    for (let i = 1; i < tokens.length; i++) {
      const token = tokens[i];

      // ---- Method ----
      if ((token === "-X" || token === "--request") && tokens[i + 1]) {
        this.method = tokens[i + 1].toUpperCase();
        i++;
      } else if (token.startsWith("-X")) {
        this.method = token.substring(2).toUpperCase();
      } else if (token.startsWith("--request=")) {
        this.method = token.split("=")[1].toUpperCase();
      }

      // ---- Headers ----
      else if ((token === "-H" || token === "--header") && tokens[i + 1]) {
        const header = tokens[i + 1];
        const [key, ...rest] = header.split(/:\s*/);
        if (!key || rest.length === 0) {
          this.util.simpleDialog({
            title: "Error",
            message: `Invalid header format: ${header}`
          });
          i++;
          continue;
        }
        this.headers.push({
          key,
          value: rest.join(": "),
          showSuggestions: false,
          filteredSuggestions: []
        });
        i++;
      }

      // ---- Form Data ----
      else if (token === "-F" || token === "--form") {
        if (tokens[i + 1]) {
          const formItem = tokens[i + 1];
          const [key, rawVal] = formItem.split("=", 2);
          let value = rawVal || "";
          let type = "text";

          if (value.startsWith("@")) {
            value = value.substring(1);
            type = "file";
          }

          this.formData.push({ key, value, type });
          if (this.method === "GET") this.method = "POST";
          this.bodyType = "form-data";
          i++;
        }
      }

      // ---- Body (raw / urlencoded / multipart string) ----
      else if (
        token === "-d" ||
        token === "--data" ||
        token === "--data-raw" ||
        token === "--data-binary"
      ) {
        if (tokens[i + 1]) {
          const bodyContent = tokens[i + 1];
          i++;

          if (this.method === "GET") this.method = "POST";

          const contentTypeHeader = this.headers.find(
            (h) => h.key.toLowerCase() === "content-type"
          );
          if (contentTypeHeader) {
            const ct = contentTypeHeader.value.toLowerCase();
            if (ct.includes("application/json")) {
              this.bodyType = "raw";
              this.rawBodyType = "JSON";
              this.body = bodyContent;
            } else if (ct.includes("application/x-www-form-urlencoded")) {
              this.bodyType = "x-www-form-urlencoded";
              this.urlEncoded = bodyContent.split("&").map((pair) => {
                const [k, v] = pair.split("=");
                return {
                  key: decodeURIComponent(k),
                  value: decodeURIComponent(v || "")
                };
              });
            } else if (ct.includes("multipart/form-data")) {
              this.bodyType = "form-data";
              const formPairs = bodyContent.split("&");
              this.formData = formPairs.map((p) => {
                const [k, v] = p.split("=");
                return { key: k, value: v, type: "text" };
              });
            } else {
              this.bodyType = "raw";
              this.rawBodyType = "Text";
              this.body = bodyContent;
            }
          } else {
            this.bodyType = "raw";
            this.rawBodyType = "JSON";
            this.body = bodyContent;
          }
        }
      }

      // ---- URL ----
      else if (token.startsWith("http://") || token.startsWith("https://")) {
        this.url = token;
        try {
          const urlObj = new URL(this.url);
          urlObj.searchParams.forEach((value, key) => {
            this.queryParams.push({ key, value });
          });
          this.url = `${urlObj.origin}${urlObj.pathname}`;
        } catch {
          this.util.simpleDialog({
            title: "Error",
            message: `Invalid URL: ${this.url}`
          });
        }
      }
    }

    // ---- GraphQL Detection ----
    if (this.bodyType === "raw" && this.body.includes('"query"')) {
      try {
        const bodyJson = JSON.parse(this.body);
        if (bodyJson.query) {
          this.bodyType = "GraphQL";
          this.graphqlQuery = bodyJson.query;
          this.graphqlVariables = bodyJson.variables
            ? JSON.stringify(bodyJson.variables, null, 2)
            : "";
        }
      } catch {
        this.util.simpleDialog({
          title: "Error",
          message: "Invalid GraphQL body JSON"
        });
      }
    }

    if(this.headers.length === 0) {
      this.headers.push({
        key: '',
        value: '',
        showSuggestions: false,
        filteredSuggestions: []
      });
    }

    if(this.queryParams.length === 0) {
      this.queryParams.push({ key: '', value: '' });
    }
    
  } catch (e: any) {
    this.util.simpleDialog({
      title: "Error",
      message: `Failed to parse cURL: ${e.message || e}`
    });
    return;
  }

  this.showCurlModal = false;
  this.curlInput = "";
}


  filterSuggestions(header: any) {
    const query = (header.key || '').toLowerCase();
    header.filteredSuggestions = this.commonHeaders
      .filter(h => h.toLowerCase().includes(query));
    header.showSuggestions = header.filteredSuggestions.length > 0;
  }

  selectSuggestion(header: any, suggestion: string) {
    header.key = suggestion;
    header.showSuggestions = false;
  }

  addHeader() {
    this.headers.push({ key: '', value: '', showSuggestions: false, filteredSuggestions: [] });
  }

  removeHeader(i: number) {
    this.headers.splice(i, 1);
  }

  // Close dropdowns when clicking outside
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const insideAutocomplete = target.closest('.autocomplete');

    if (!insideAutocomplete) {
      this.headers.forEach(h => (h.showSuggestions = false));
    }
  }

  //Clear all fields
  clearAll() {
    // Reset method & URL
    this.method = 'GET';
    this.url = '';

    // Reset query params
    this.queryParams = [{ key: '', value: '' }];

    // Reset headers
    this.headers = [
      {
        key: '',
        value: '',
        showSuggestions: false,
        filteredSuggestions: []
      }
    ];

    // Reset body related fields
    this.bodyType = 'none';
    this.rawBodyType = 'JSON';
    this.body = '';
    this.formData = [];
    this.urlEncoded = [];
    this.binaryFile = null;
    this.graphqlQuery = '';
    this.graphqlVariables = '';

    // Reset response
    this.response = null;
    this.dataToRender = null;
    this.selectedAttribute = '';
    this.isArray = false;
    this.currentPage = 1;
    this.totalPages = 1;
    this.selected.clear();
    this.selectAllAcrossPages = false;
  }

}